import React from 'react';

/**
 * MailListSkeleton — shimmer placeholder rows shown while the first page loads.
 */
export default function MailListSkeleton({ rows = 8 }) {
  return (
    <div className="ivx-skeleton-list">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="ivx-skeleton-item" style={{ animationDelay: `${i * 0.06}s` }}>
          <div className="ivx-skeleton-avatar ivx-shimmer" />
          <div className="ivx-skeleton-lines">
            <div className="ivx-skeleton-line ivx-shimmer" style={{ width: '60%' }} />
            <div className="ivx-skeleton-line ivx-shimmer" style={{ width: '85%' }} />
            <div className="ivx-skeleton-line ivx-shimmer" style={{ width: '45%' }} />
          </div>
        </div>
      ))}
    </div>
  );
}
